/**
 * Custom per-product label shown on top of the product image.
 *
 * The store admin defines the label *text* per product and picks its *color*
 * from the store's own color scheme. The color options below are expressed as
 * Tailwind brand/secondary utilities which are re-mapped to the store's chosen
 * palette inside any `[data-store-theme]` subtree (see
 * themes/applyStoreTheme.js). That way the label automatically matches whatever
 * theme the admin selected for the store — no per-product hex values needed.
 *
 * Shape stored on a product: `label: { text: string, color: string }`
 * where `color` is one of the `key`s below.
 */
export const PRODUCT_LABEL_COLORS = [
    // Brand family — full lightness range (text color flips for contrast).
    { key: 'brand-100', name: 'ראשי 100', badgeClass: 'bg-brand-100 text-brand-900', swatchClass: 'bg-brand-100' },
    { key: 'brand-200', name: 'ראשי 200', badgeClass: 'bg-brand-200 text-brand-900', swatchClass: 'bg-brand-200' },
    { key: 'brand-300', name: 'ראשי 300', badgeClass: 'bg-brand-300 text-brand-900', swatchClass: 'bg-brand-300' },
    { key: 'brand-400', name: 'ראשי 400', badgeClass: 'bg-brand-400 text-white',     swatchClass: 'bg-brand-400' },
    { key: 'brand',     name: 'ראשי 500', badgeClass: 'bg-brand-500 text-white',     swatchClass: 'bg-brand-500' },
    { key: 'brand-600', name: 'ראשי 600', badgeClass: 'bg-brand-600 text-white',     swatchClass: 'bg-brand-600' },
    { key: 'brand-700', name: 'ראשי 700', badgeClass: 'bg-brand-700 text-white',     swatchClass: 'bg-brand-700' },
    { key: 'brand-800', name: 'ראשי 800', badgeClass: 'bg-brand-800 text-white',     swatchClass: 'bg-brand-800' },
    { key: 'brand-900', name: 'ראשי 900', badgeClass: 'bg-brand-900 text-white',     swatchClass: 'bg-brand-900' },
    // Secondary / accent family (only 500 & 600 follow the store scheme).
    { key: 'secondary',      name: 'משני 500', badgeClass: 'bg-secondary-500 text-white', swatchClass: 'bg-secondary-500' },
    { key: 'secondary-dark', name: 'משני 600', badgeClass: 'bg-secondary-600 text-white', swatchClass: 'bg-secondary-600' },
];

export const DEFAULT_PRODUCT_LABEL_COLOR = 'brand';

/** Resolve a stored color key to its option (falls back to the default). */
export const getProductLabelColor = (key) =>
    PRODUCT_LABEL_COLORS.find((c) => c.key === key) || PRODUCT_LABEL_COLORS[0];

/** Normalized label text for a product, or '' when none is set. */
export const getProductLabelText = (product) => (product?.label?.text || '').trim();
